import { BanIcon, ShieldBanIcon } from "lucide-react"
import { OrderProvider } from "@/contexts/OrderContext";
import { AudioProvider } from "@/contexts/AudioContext";
import OrderHeader from "@/pages/order/OrderHeader";

export function Forbidden() {
    return <div className="flex flex-grow flex-col items-center justify-center h-screen">
        <ShieldBanIcon className="w-16 h-16 mb-4" />
        <h1 className="text-xl font-bold">Accès refusé</h1>
        <p className="text-md mb-4">Vous n'avez pas la permission d'accéder à cette ressource.</p>
    </div>
}

export function NotFound() {
    return <div className="flex flex-grow flex-col items-center justify-center h-screen">
        <BanIcon className="w-16 h-16 mb-4" />
        <h1 className="text-xl font-bold">Page non trouvée</h1>
        <p className="text-md mb-4">Désolé, la page que vous recherchez n'existe pas.</p>
    </div>
}



export function NotFoundPage() {
    return <OrderProvider>
        <AudioProvider>
            <div className="flex flex-col h-screen min-h-0">
                <OrderHeader />
                <NotFound />
            </div>
        </AudioProvider>
    </OrderProvider>
}